<template>
    <div class="of-content3-slider-funnels">
        <div class="of-c3-sf-title" v-html="sliderFunnels.title"></div>
        <div class="of-c3-sf-wrapper">
            <div class="slider-funnels">
                <div class="sf-prev" @click="prev">
                    <span class="fa fa-angle-left"></span>
                </div>
                <!-- disable swipe @mousedown="mouseDown" @mouseup="mouseUp" --> 
                <div :class="['sf-container', swipping ? 'swipe' : '']" ref="container">
                    <div
                        v-for="(slide, index) in computedSlides"
                        :key="index"
                        :class="['sf-container-item', index == activeIndex ? 'active' : '']"
                        :style="{
                            marginLeft: index == 0 ? `-${(activeIndex*100)}%` : ''
                        }"
                    >
                       <funnel-card
                            class="funnel-card"
                            v-for="(card, j) in slide"
                            :key="index+'-'+j"
                            :view="card"
                        />
                    </div>
                </div>
                <div class="sf-next" @click="next">
                    <span class="fa fa-angle-right"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FunnelCard  from "./FunnelCard.vue";

    export default {
        name: 'slider-funnels',
        props: ['view'],
        components: {
            'funnel-card': FunnelCard
        },
        data: function() {
            return {
                fallback: {
                    title: 'New Funnels of The Month',
                    slides: [
                        {
                            link: '#',
                            baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                            thumb: {
                                img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                                text: 'Show Funnel'
                            },
                            title: 'Chat Bot Funnel',
                            subtitle: "PFF004 EN - Weight Loss Detox",
                            button: {
                                label: 'Download',
                                link: '#',
                                baIntelligenceTag: 'fc-c10-download-new-funnel-of-month-us-x-y'
                            }
                        },
                        {
                            link: '#',
                            baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                            thumb: {
                                img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                                text: 'Show Funnel'
                            },
                            title: 'Chat Bot Funnel',
                            subtitle: "PFF004 EN - Weight Loss Detox",
                            button: null
                        },
                        {
                            link: '#',
                            baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                            thumb: {
                                img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                                text: 'Show Funnel'
                            },
                            title: 'Chat Bot Funnel',
                            subtitle: "PFF004 EN - Weight Loss Detox",
                            button: null
                        },
                        {
                            link: '#',
                            baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                            thumb: {
                                img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                                text: 'Show Funnel'
                            },
                            title: 'Chat Bot Funnel',
                            subtitle: "PFF004 EN - Weight Loss Detox",
                            button: null
                        },
                        {
                            link: '#',
                            baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                            thumb: {
                                img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                                text: 'Show Funnel'
                            },
                            title: 'Chat Bot Funnel',
                            subtitle: "PFF004 EN - Weight Loss Detox",
                            button: null
                        },
                        {
                            link: '#',
                            baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                            thumb: {
                                img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                                text: 'Show Funnel'
                            },
                            title: 'Chat Bot Funnel',
                            subtitle: "PFF004 EN - Weight Loss Detox",
                            button: null
                        },
                        {
                            link: '#',
                            baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                            thumb: {
                                img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                                text: 'Show Funnel'
                            },
                            title: 'Chat Bot Funnel',
                            subtitle: "PFF004 EN - Weight Loss Detox",
                            button: null
                        },
                        {
                            link: '#',
                            baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                            thumb: {
                                img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                                text: 'Show Funnel'
                            },
                            title: 'Chat Bot Funnel',
                            subtitle: "PFF004 EN - Weight Loss Detox",
                            button: null
                        },
                        {
                            link: '#',
                            baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                            thumb: {
                                img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                                text: 'Show Funnel'
                            },
                            title: 'Chat Bot Funnel',
                            subtitle: "PFF004 EN - Weight Loss Detox",
                            button: null
                        },
                        {
                            link: '#',
                            baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                            thumb: {
                                img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                                text: 'Show Funnel'
                            },
                            title: 'Chat Bot Funnel',
                            subtitle: "PFF004 EN - Weight Loss Detox",
                            button: null
                        },
                        {
                            link: '#',
                            baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                            thumb: {
                                img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                                text: 'Show Funnel'
                            },
                            title: 'Chat Bot Funnel',
                            subtitle: "PFF004 EN - Weight Loss Detox",
                            button: null
                        },
                        {
                            link: '#',
                            baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                            thumb: {
                                img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                                text: 'Show Funnel'
                            },
                            title: 'Chat Bot Funnel',
                            subtitle: "PFF004 EN - Weight Loss Detox",
                            button: null
                        }
                    ]
                },
                // variaveis locais
                activeIndex: 2,
                mouseXPosition: 0,
                swipping: false,
                computedSlides: []
            }
        },
        methods: {
            prev: function () {
                if(this.activeIndex == 0) {
                    this.activeIndex = this.computedSlides.length-1
                } else {
                    this.activeIndex--
                }
            },
            next: function () {
                if(this.activeIndex == this.computedSlides.length-1) {
                    this.activeIndex = 0
                } else {
                    this.activeIndex++
                }
            },
            mouseDown(e) {
                this.mouseXPosition = e.pageX
                this.swipping = true
            },
            mouseUp(e) {
                let diff = e.pageX - this.mouseXPosition
                if( Math.abs(diff) < 100 ){
                    // desconsidera swipe menor que 100 px
                } else if(diff < 0) {
                    //swipe left
                    this.next();
                } else {
                    //swipe right
                    this.prev();
                }
                this.mouseXPosition = e.pageX
                this.swipping = false
            },
            openTab: function(link) {
                window.open(link, '_blank')
            },
            windowResize(e) {
                let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
                if( w <= 768) {
                    this.$set(this.$data, 'computedSlides', this.recalculateSlides(1))
                    this.activeIndex = 0
                } else if(w >= 769 && w <= 1365) {
                    this.$set(this.$data, 'computedSlides', this.recalculateSlides(2))
                    this.activeIndex = 0
                } else {
                    this.$set(this.$data, 'computedSlides', this.recalculateSlides(3))
                    this.activeIndex = 0
                }
            },
            recalculateSlides: function(partSize = 3) {
                let qtdInterations = Math.ceil(this.sliderFunnels.slides.length / partSize)
                let arr = []
                for(let i = 0, start = 0; i < qtdInterations; i++, start+=partSize) {
                    arr.push(this.sliderFunnels.slides.slice(start, start+partSize))
                }
                return arr

            }
        },
        computed: {
            sliderFunnels: function () {
                return (this.view !== undefined && this.view !== null) ? this.view : this.fallback
            }
        },
        mounted(){
            window.addEventListener('resize', this.windowResize)
            this.windowResize()
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../../../scss/office";

    .swipe{
        cursor: move!important;
    }
    .of-content3-slider-funnels{
        font: inherit;
        padding: 0;
        .of-c3-sf-title{
            font: inherit;
            color: $of-color1;

            font-family: "Mulish";
            font-weight: 700;
            font-size: 5em; /*50px*/
            line-height: 1.2;

            padding-bottom: 0.96em; /* 48px */
        }
        .of-c3-sf-wrapper{
            font: inherit;
            /* border: 1px blue solid; */

            .slider-funnels{
                font: inherit;

                display: grid;
                grid-template-columns: 5em auto 5em;
                grid-template-rows: auto;
                justify-items: stretch;
                align-items: stretch;
                justify-content: stretch;
                align-content: stretch;

                min-height: 250px;

                .sf-container{
                    font: inherit;
                    max-width: 100%;
                    
                    overflow: hidden;
                    display: flex;
                    flex-wrap: nowrap;

                    .sf-container-item{
                        font: inherit;
                        min-width: 100%;
                        height: 100%;
                        transition: margin-left 2s;



                        display: grid;
                        grid-template-columns: repeat(3, 1fr);
                        grid-template-rows: auto;
                        padding: 3.2em 3.2em;
                        column-gap: 3.2em; /*32px*/
                        row-gap: 3.2em; /*32px*/
                        justify-items: stretch;
                        align-items: space-around;
                        justify-content: space-around;
                        align-content: stretch;
                    
                    }
                }
                .sf-prev,
                .sf-next{
                    font: inherit;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                
                    &:hover{
                        cursor: pointer;
                        box-shadow: inset 0 0 0.5em $of-color20;
                        border-radius: 0.266666667em;
                    }
                    span{
                        font-size: 4em;
                        color: $of-color2;
                    }
                }
            }
        }
    }


    @media (max-width: 768px) { /* smartphones */
        .of-content3-slider-funnels{
            .of-c3-sf-wrapper{
                .slider-funnels{
                    .sf-container{
                        .sf-container-item{
                            grid-template-columns: 1fr;
                        }
                    }
                }
            }
        }

    }
    @media (min-width: 769px) and (max-width: 1365px) { /* tablets */
        .of-content3-slider-funnels{
            .of-c3-sf-wrapper{
                .slider-funnels{
                    .sf-container{
                        .sf-container-item{
                            grid-template-columns: 1fr 1fr;
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/dashboard/onboardingFunnel/content-10/SliderFunnels.vue